import type { ReactNode } from "react";

interface Props {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export function LegalPlaceholder({ title, lastUpdated, children }: Props) {
  return (
    <section className="mx-auto max-w-3xl px-6 py-20">
      <p className="mb-3 text-sm uppercase tracking-widest text-muted-foreground">
        Legal
      </p>
      <h1 className="text-4xl font-semibold tracking-tight">{title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Last updated: {lastUpdated}
      </p>
      <div className="prose prose-sm mt-10 max-w-none space-y-5 text-muted-foreground">
        {children}
      </div>
    </section>
  );
}
